import MenuItem from "./MenuItem";

export default ( props ) => {
	const {
		column,
		handleSubmenuToggle,
	} = props;

	if ( ! column.parentItem || column.depth === 0 ) return;

	const targetDepth = column.activeID > -1
		? column.depth
		: column.depth - 1;

	const targetMenuItemID = column.activeID > -1
		? column.activeID
		: column.parentItem.ID;

	return (
		<>
			<ul className="ps-0 my-0 list-none">
				<MenuItem
					depth={column.depth || 1 }
					activeID={column.parentItem?.ID}
					ID={column.parentItem?.ID}
					url={column.parentItem?.url}
					title={column.parentItem?.title}
					handleSubmenuToggle={() => handleSubmenuToggle( targetDepth, targetMenuItemID )}
					hasChildren={true}
					isOverview={false}
					isBack={true}
				/>
			</ul>
		</>
	);
};
